export default "__VITE_ASSET__Cs9Krt_0__"